export default "__VITE_ASSET__fe4a5fa9__"